
<template>
  <div
    ref="VChartComponentWrap"
    class="VChartComponentWrap"
  >
    <div
      ref="header"
      class="VChartComponentWrap__header"
    >
      <div class="title">
        {{ element.label }}
      </div>
      <div
        class="radio"
        :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
      >
        <div
          class="radioBtn "
          :class="{active:tabType==='day'}"
          @click="setTabType('day')"
        >按日</div>
        <div
          class="radioBtn"
          :class="{active:tabType==='month'}"
          @click="setTabType('month')"
        >按月</div>
      </div>
      <div
        v-if="element.componentType === 'ElectricalCondition'"
        class="addUp"
      >
        累计
        <div class="num">
          {{ countData.sumElectricity }}
        </div>
        KW.h
      </div>
      <div
        v-if="element.componentType === 'LeakageMonitor'"
        class="addUp"
      >
        累计
        <div class="num">
          {{ countData.sumLeakageElectricity }}
        </div>
        mA
      </div>
    </div>
    <div
      ref="chartWrap"
      class="chartWrap"
    >
      <VchartComponent
        ref="VchartComponent"
        v-bind="$attrs"
        :element="element"
        :prop-value="propValue"
      />
    </div>
  </div>
</template>

<script>
import VchartComponent from './VChartComponent.vue'
import {
  queryElectricityDayData,
  queryElectricityMonthData
} from '@/api/manage'
import moment from 'moment'
import { mapState } from 'vuex'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import _ from 'lodash'
export default {
  components: { VchartComponent },
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    propValue: {
      type: Object,
      require: true,
      default: () => {}
    },
    personData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    areaIdList: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {
      apiList: {
        ElectricalCondition: {
          api: queryElectricityDayData,
          month: queryElectricityMonthData
        },
        LeakageMonitor: {
          api: queryElectricityDayData,
          month: queryElectricityMonthData
        },
        ElectricalWarn: {
          api: queryElectricityDayData,
          month: queryElectricityMonthData
        },
        ElectricalStatistics: {
          api: queryElectricityDayData,
          month: queryElectricityMonthData
        }
      },
      countData: {},
      tabType: 'day'
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    }),
    titleFontSize() {
      const px = Math.ceil(16 / window.devicePixelRatio)
      return px
    },
    rateFontSize() {
      const px = Math.ceil(26 / window.devicePixelRatio)
      return px
    }
  },
  watch: {
    'element.style': {
      deep: true,
      handler(val) {
        this.setHeight()
      }
    }
  },
  created() {
    this.getData()
    this.timer = setInterval(() => {
      this.getData()
    }, 600000)
  },

  destroyed() {
    clearInterval(this.timer)
  },
  mounted() {
    this.setHeight = _.debounce(this.setHeight, 300)
    this.setHeight()
  },
  methods: {
    setHeight() {
      const height =
        this.$refs.VChartComponentWrap.clientHeight -
        this.$refs.header.clientHeight
      this.$refs.chartWrap.style.height = height + 'px'
      this.$refs.VchartComponent.render()
    },
    changeDevicePixelRatio,
    setAttendanceRate() {
      if (this.element.componentType === 'AttendanceRate') {
        this.propValue.option.series[0].data[0].value =
          this.personData.onJobCount - this.personData.inCount
        this.propValue.option.series[0].data[1].value = this.personData.inCount
        this.$refs.VchartComponent.render()
      }
    },
    setTabType(tabType) {
      this.tabType = tabType
      this.getData()
    },
    getData() {
      const form = {
        month: moment().format('YYYY-MM'),
        pageNumber: 1,
        pageSize: 10,
        projectId: this.projectItem.projectId,
        areaIdList: this.areaIdList
      }
      let method =
        this.apiList[this.element.componentType] &&
        this.apiList[this.element.componentType].api
      if (this.tabType === 'month') {
        method =
          this.apiList[this.element.componentType] &&
          this.apiList[this.element.componentType].month
      }
      method(form).then((res) => {
        this.countData = res.data
        let hourDataMap = res.data.hourDataMap
        if (this.tabType === 'month') {
          hourDataMap = res.data.dayDataMap
        }
        const xData = Object.keys(hourDataMap)
        if (this.tabType === 'day') {
          xData.sort(function (a, b) {
            return a - b
          })
        } else {
          xData.sort(function (a, b) {
            const c = a.split('-')[2]
            const d = b.split('-')[2]
            return c - d
          })
        }
        if (this.element.componentType === 'ElectricalCondition') {
          const hourSumElectricity = []
          xData.forEach((element) => {
            if (this.tabType === 'day') {
              hourSumElectricity.push(hourDataMap[element].hourSumElectricity)
            } else {
              hourSumElectricity.push(hourDataMap[element].daySumElectricity)
            }
          })

          this.$set(this.propValue.option.xAxis[0], 'data', xData)
          this.$set(this.propValue.option.series[0], 'data', hourSumElectricity)
        }
        if (this.element.componentType === 'LeakageMonitor') {
          const hourSumLeakageElectricity = []
          xData.forEach((element) => {
            if (this.tabType === 'day') {
              hourSumLeakageElectricity.push(
                hourDataMap[element].hourSumLeakageElectricity
              )
            } else {
              hourSumLeakageElectricity.push(
                hourDataMap[element].daySumLeakageElectricity
              )
            }
          })
          this.$set(this.propValue.option.xAxis[0], 'data', xData)
          this.$set(
            this.propValue.option.series[0],
            'data',
            hourSumLeakageElectricity
          )
        }
        if (this.element.componentType === 'ElectricalWarn') {
          const data = [
            { value: 0, name: '温度' },
            { value: 0, name: '电流过载' },
            { value: 0, name: '电压中断' },
            { value: 0, name: '电压低压' },
            { value: 0, name: '电压高压' }
          ]
          data[0].value = res.data.tCount
          data[1].value = res.data.otCount
          data[2].value = res.data.vLCount
          data[3].value = res.data.lVCount
          data[4].value = res.data.hVCount
          this.$set(this.propValue.option.series[0], 'data', data)
        }
        if (this.element.componentType === 'ElectricalStatistics') {
          const areaDataMap = res.data.areaDataMap
          const xData = Object.keys(areaDataMap)
          const hourSumLeakageElectricity = []
          for (const key in areaDataMap) {
            if (Object.hasOwnProperty.call(areaDataMap, key)) {
              const element = areaDataMap[key]
              hourSumLeakageElectricity.push(element)
            }
          }
          this.$set(this.propValue.option.xAxis[0], 'data', xData)
          this.$set(
            this.propValue.option.series[0],
            'data',
            hourSumLeakageElectricity
          )
        }
        // if (this.element.componentType === 'InsidePersonCount') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.hour))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.workerCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.managerCount))
        // } else if (this.element.componentType === 'InOutPersonCount') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.hour))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.inCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.outCount))
        // } else if (this.element.componentType === 'AttendanceTeam') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.teamName))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.personCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.verifyCount))
        // } else if (this.element.componentType === 'AttendanceWokerType') {
        //   this.$set(this.propValue.option.xAxis[0], 'data', res.data.map(item => item.workerTypeName))
        //   this.$set(this.propValue.option.series[0], 'data', res.data.map(item => item.personCount))
        //   this.$set(this.propValue.option.series[1], 'data', res.data.map(item => item.verifyCount))
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.VChartComponentWrap {
  width: 100%;
  height: 100%;
  position: relative;

  &__header {
    padding: 2%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .title {
      color: #00ccff;
      font-weight: bold;
    }
    .radio {
      border: 1px solid #00c8fc;
      border-radius: 3px;
      display: flex;
      width: 20%;
      .radioBtn {
        text-align: center;
        color: #486c93;
        line-height: 1.5;
        white-space: nowrap;
        width: 50%;
        cursor: pointer;
      }
      .active {
        color: #edf7ff;
        background: #1890ff;
      }
    }
    .addUp {
      color: #fff;
      position: absolute;
      top: 25%;
      left: 50%;
      display: flex;
      align-items: baseline;
      font-weight: bold;
      transform: translate(-50%);
      .num {
        color: #ffff04;
        font-weight: bold;
      }
    }
  }
  .wrapping {
    display: flex;
    justify-content: center;
    .item {
      text-align: center;
      color: #fff;
      width: 30%;
      border-radius: 4px;
      padding: 2% 0;
      background: #00448d;
      &:first-child {
        margin-right: 4%;
      }
    }
  }
  .chartWrap {
    width: 100%;
    height: calc(100% - 30%);
  }
}
</style>
